module.exports = __webpack_public_path__ + "img/bus-outline-round.3659da2c.svg";